<template>
  <div id="BidApprove">
    <loading-overlay v-if="isLoading"></loading-overlay>
    <div class="search">
      <el-form ref="form" :model="form" label-width="90px">
        <el-row>
          <el-col :span="4">
            <el-form-item label="招标人" prop="tenderee">
              <el-input
                v-model="form.tenderee"
                placeholder="请输入"
                class="select"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="申请人" prop="applicant">
              <el-input
                v-model="form.applicant"
                placeholder="请输入"
                class="select"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="发布时间">
              <el-date-picker
                class="select"
                v-model="form.starttime"
                type="date"
                placeholder="全部-起始"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width="10px">
              <el-date-picker
                class="select"
                v-model="form.endtime"
                type="date"
                placeholder="全部-终止"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-button type="primary" @click="GetSearch">搜索</el-button>
              <el-button @click="reset('form')">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="12">
            <el-form-item label="投标状态">
              <el-select v-model="form.status" placeholder="请选择" class="select">
                <el-option v-for="item in Status" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
    </div>

    <div class="main">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
      >
        <el-table-column prop="tenderee" label="招标人"> </el-table-column>
        <el-table-column prop="procurefile" label="采购文件名称">
        </el-table-column>

        <el-table-column prop="applicant" label="申请人"> </el-table-column>
        <el-table-column prop="publishDate" label="发布时间">
          <template slot-scope="scope" v-if="scope.row.publishDate">
            {{ handleTime(scope.row.publishDate) }}
          </template>
        </el-table-column>
        <el-table-column label="当前状态" prop="status">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1" type="text" class="casestatus"
              >审批中</span
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="210">
          <template slot-scope="scope">
            <el-button
              class="tg"
              size="small"
              @click="approval(scope.row.id, 0)"
              v-if="$store.state.rolesname.includes('BidApprove_pass')"
              >通过</el-button
            >
            <el-button
              class="bh"
              size="small"
              @click="approval(scope.row.id, 1)"
              v-if="$store.state.rolesname.includes('BidApprove_refuse')"
              >驳回</el-button
            >
            <el-button
              class="look"
              size="small"
              @click="Look(scope.row.id)"
              v-if="$store.state.rolesname.includes('BidApprovedetail')"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="bank_pagination">
        <el-pagination
          :hide-on-single-page="value"
          :current-page.sync="PageIndex"
          :page-sizes="PageSizes"
          :page-size="PageSize"
          :pager-count="MaxPage"
          layout="total, sizes, prev, pager, next"
          :total="Total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          v-if="bPageShow"
        />
      </div>
    </div>

    <!--更多选择!-->
    <el-dialog
      title="搜索"
      :visible.sync="dialogVisible"
      width="45%"
      center
      :show-close="false"
    >
      <el-form ref="form" :model="form" label-width="90px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="招标人" prop="tenderee">
              <el-input
                v-model="form.tenderee"
                placeholder="请输入"
                class="select"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请人" prop="applicant">
              <el-input
                v-model="form.applicant"
                placeholder="请输入"
                class="select"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="发布时间">
              <el-date-picker
                class="select"
                v-model="form.starttime"
                type="date"
                placeholder="全部-起始"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label-width="10px">
              <el-date-picker
                class="select"
                v-model="form.endtime"
                type="date"
                placeholder="全部-终止"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="12">
            <el-form-item label="投标状态">
              <el-select v-model="form.status" placeholder="请选择" class="select">
                <el-option v-for="item in Status" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
      <div class="btn">
        <el-button type="primary" @click="GetSearch">搜索</el-button>
        <el-button @click="reset('form')">重置</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="title"
      :visible.sync="approvaldialog"
      width="30%"
      center
      :show-close="false"
      @close="handleCancle"
    >
      <div class="fail" v-if="title">
        <el-form
          :model="failform"
          label-width="80px"
          ref="failformref"
          :rules="failformrules"
        >
          <el-form-item prop="Reason" label="驳回原因">
            <el-input
              v-model="failform.Reason"
              :autosize="{ minRows: 8 }"
              type="textarea"
            />
          </el-form-item>
        </el-form>
        <div class="refuse">
          <el-button @click="refuse('failformref')" type="primary"
            >驳回</el-button
          >
        </div>
      </div>
      <div class="success" v-else>
        <div><img src="../../assets/success.svg" /></div>
        <div class="pass">已通过</div>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import { Tender, TenderSuccess, TenderReject } from '../../api/examine'
var reason = (rule, value, callback) => {
  if (value == '' || value == undefined || value == null) {
    callback()
  } else {
    if (value.match(/^[ ]*$/)) {
      callback(new Error('驳回原因不能为空'))
    }
  }
  callback()
}
export default {
  name: 'BidApprove',
  data() {
    return {
      isLoading: false,
      bPageShow: true,
      sLoading: false,
      next: true, //是否是三级菜单
      Con: '',
      more: '',
      dialogVisible: false,
      form: {
        tenderee: '',
        applicant: '',
        endtime: null,
        starttime: null,
        status: null
      },
      Status: [
        { label: '已通过', value: 0 },
        { label: '一审', value: 1 },
        { label: '待审核', value: 2 }
      ],
      // CaseType:[{ label: "已通过", value: 0 }, { label: "一审", value: 1 }],
      dialogVisible: false, //弹出框
      IsorNo: [
        { label: '是', value: 0 },
        { label: '否', value: 1 }
      ],
      Casetype: [
        { label: '民事案件', value: '民事案件' },
        { label: '破产案件', value: '破产案件' }
      ],

      tableData: [],
      PageSizes: [10, 20, 50, 100],
      PageIndex: 1,
      PageSize: 10,
      Total: 0,
      MaxPage: 5,
      value: false, //只有一页的时候隐藏分页
      //审核弹出框
      approvaldialog: false,
      title: '',
      failform: {},
      failformrules: {
        Reason: [
          { required: true, message: '驳回原因不能为空', trigger: 'change' },
          { validator: reason, trigger: 'blur' }
        ]
      }
    }
  },

  methods: {
    getvalue() {
      //传值给父组件，
      this.$emit('value', this.next)
    },
    approval(id, type) {
      //审核
      var header = document.getElementsByClassName('el-dialog__header')
      if (type == 0) {
        this.isLoading = true
        TenderSuccess({ Id: id }).then((res) => {
          if (res.data.status == 'success') {
            this.title = ''
            header[1].style.display = 'none'
            this.approvaldialog = true
            this.Search()
          } else if (
            res.data.status == '401' ||
            res.data.status == '402' ||
            res.data.status == '403'
          ) {
            this.$message.error(res.data.message)
            window.sessionStorage.removeItem('token')
            window.sessionStorage.removeItem('hasRoles')
            this.$router.push('/login')
          } else {
            this.$message.error(res.data.message)
          }
          this.isLoading = false
        })
      }
      if (type == 1) {
        this.title = '驳回原因'
        header[1].style.display = ''
        this.approvaldialog = true
        this.failform.id = id
      }
    },
    reset() {
      this.form.tenderee = ''
      this.form.applicant = ''
      this.form.status = null
      this.form.starttime = null
      this.form.endtime = null
    },
    refuse(form) {
      this.$refs[form].validate((success) => {
        if (success) {
          this.isLoading = true
          TenderReject({
            Id: this.failform.id,
            Reason: this.failform.Reason
          }).then((res) => {
            if (res.data.status == 'success') {
              this.$message.success('审核成功')
              this.Search()
            } else if (
              res.data.status == '401' ||
              res.data.status == '402' ||
              res.data.status == '403'
            ) {
              this.$message.error(res.data.message)
              window.sessionStorage.removeItem('token')
              window.sessionStorage.removeItem('hasRoles')
              this.$router.push('/login')
            } else {
              this.$message.error(res.data.message)
            }
            this.isLoading = false
          })
          this.approvaldialog = false
        } else {
          this.$message.error('有必填项为空！')
          return false
        }
      })
    },
    handleCancle() {
      if (this.title != '') {
        this.$refs.failformref.resetFields()
      }
    },
    Look(id) {
      //查看
      this.$router.push({
        path: '/home/seal/BidApprovedetail',
        query: {
          guid: id,
          dayin: true
        }
      })
    },
    GetSearch() {
      this.PageIndex = 1
      this.Search()
    },
    Search() {
      //查询
      this.isLoading = true
      var starttime = null
      var endtime = null
      if (this.form.starttime) {
        starttime = this.JsonTime(this.form.starttime)
      }
      if (this.form.endtime) {
        endtime = this.JsonTime(this.form.endtime)
      }
      Tender({
        page: this.PageIndex,
        rows: this.PageSize,
        Tenderee: this.form.tenderee,
        Applicant: this.form.applicant,
        Status: this.form.status,
        StartTime: starttime,
        EndTime: endtime
      }).then((res) => {
        if (res.data.status == 'success') {
          this.tableData = res.data.data
          this.Total = res.data.total
          this.dialogVisible = false
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
        this.isLoading = false
      })
    },
    moreSelect() {
      //更多选择
      this.$refs.choose.blur()
      this.dialogVisible = true
    },
    handleSizeChange(val) {
      this.PageSize = val
      this.Search()
    },
    handleCurrentChange(val) {
      this.PageIndex = val
      this.Search()
    },
    // 时间格式
    handleTime(time) {
      // yyyy-MM-dd
      var t = new Date(time)
      var time = t.getFullYear() + '-' + (t.getMonth() + 1) + '-' + t.getDate()
      return time
    },
    JsonTime(date) {
      // yyyy-MM-ddT HH:MM:SS
      var t = new Date(date).getTime()
      var d = new Date(t + 8 * 3600 * 1000).toISOString()
      return d
    }
  },
  created() {
    this.getvalue()
    // this.Search()
  },
  beforeRouteLeave(to, from, next) {
    const type = 'BidApprovePage'
    if (to.name == 'BidApprovedetail') {
      var con = {
        form: this.form,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize
      }
      this.$store.dispatch('saveSearchCondition', { type, condition: con }) //保存
    } else {
      this.$store.dispatch('clearSearchConditions', type) //保存
    }

    next()
  },
  beforeRouteEnter(to, from, next) {
    // 辅助函数，用于在组件实例化之前执行一些代码
    function fetchData() {
      const type = 'BidApprovePage'
      // console.log("获取")
      // 从 Vuex store 中读取搜索条件
      if (this.$store.state.searchConditions[type]) {
        return this.$store.state.searchConditions[type]
      }
      return null
    }
    // 通过 next 回调访问组件实例
    next((vm) => {
      const fetchedData = fetchData.call(vm)
      if (fetchedData && from.name == 'BidApprovedetail') {
        vm.form = fetchedData.form
        console.log('dasd')
        vm.PageIndex = fetchedData.PageIndex
        vm.PageSize = fetchedData.PageSize
        // console.log(fetchedData.PageIndex)
        vm.bPageShow = false
        vm.$nextTick(() => {
          vm.bPageShow = true
        })
        vm.Search()
      } else {
        vm.Search()
      }
    })
  }
}
</script>
  
<style lang="less" scoped>
// 查询
.search {
  box-sizing: border-box;
  width: 100%;
  // margin: auto;
  // display: flex;

  padding: 20px;
  // margin-bottom: 24px;
}

.search ::v-deep .el-input__inner {
  // width: 80% !important;
  // width: 300px;
  background-color: #fafafa;
  border: 0 !important;
  border-radius: 12px;
}

.nameSearch {
  width: 24vw;
  margin-right: 10px;
}

// .select {
//   width: 10vw;
//   margin-right: 10px;
// }

// 弹出框
/deep/.el-dialog__header {
  padding: 10px 10px 10px;
  background: rgba(250, 250, 250, 1);
  font-size: 18px;
}

//表格
.casestatus {
  color: rgba(254, 150, 74, 1);
}

.btn {
  width: 100%;
  text-align: center;
}

.tg {
  background: #e7f7ef;
  border-radius: 8px;
  color: #0caf60;
  border: none;
}

.bh {
  background: #fff0e6;
  border-radius: 8px;
  color: #fe964a;
  border: none;
}

.look {
  background: #eff5ff;
  border-radius: 8px;
  color: #3077e6;
  border: none;
}

// 分页
.bank_pagination {
  text-align: right;
  margin-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

/deep/.el-pagination__total {
  float: left;
}

/deep/.el-pagination__sizes {
  float: left;
}

// 弹出框
#BidApprove /deep/.el-dialog__header {
  padding: 10px 10px 10px;
  background: rgba(250, 250, 250, 1);
  font-size: 18px;
}

#BidApprove .success {
  width: 100%;
  text-align: center;
  display: inline-flex;
  flex-direction: column;
}

#BidApprove .pass {
  color: #718096;
  font-size: 24px;
  margin-top: 12px;
}

#BidApprove .fail {
  width: 100%;
}

#BidApprove .refuse {
  width: 100%;
  text-align: center;
}
</style>
  